export const opOptions = [1001, 1002, 1003, 1004, 1005];
export const diagnosisOptions = ["Appendicitis", "Cholecystitis", "Hernia", "Fracture", "Other"];
export const procedureOptions = ["Appendectomy", "Cholecystectomy", "Hernia Repair", "Fracture Fixation", "Other"];

export const illnessMapping = {
  cvs: [
    { name: "Chest Pain", key: "cvs_chest_pain" },
    { name: "Breathlessness", key: "cvs_breathlessness" },
    { name: "Palpitation", key: "cvs_palpitation" },
    { name: "Hypertension", key: "cvs_hypertension" },
    { name: "IHD", key: "cvs_ihd" },
  ],
  rs: [
    { name: "Fever", key: "rs_fever" },
    { name: "Cough & Sputum", key: "rs_cough_sputum" },
    { name: "Asthma", key: "rs_asthma" },
    { name: "COPD", key: "rs_copd" },
    { name: "Pul TB", key: "rs_pul_tb" },
    { name: "Sneezing", key: "rs_sneezing" },
  ],
  git: [
    { name: "APD", key: "git_apd" },
    { name: "Jaundice", key: "git_jaundice" },
  ],
  gns: [
    { name: "Stroke", key: "gns_stroke" },
    { name: "Seizures", key: "gns_seizures" },
    { name: "Pollo", key: "gns_polio" },
    { name: "LOC", key: "gns_loc" },
    { name: "Head Injury", key: "gns_head_injury" },
  ],
};

export const spineOptionsTypes = ["Normal", "Abnormal", "Degenerative", "Fractured", "Other"];

export const effortToleranceOptions = ["Low", "Moderate", "High", "Very High"];

export const dentitionOptions = ["Normal", "Missing Teeth", "Caries", "Partial Denture", "Full Denture"];

export const vitalsOptions = {
  pr: ["60", "70", "80", "90", "100"],
  bp: ["110/70", "120/80", "130/85", "140/90"],
  spo2: ["95", "96", "97", "98", "99", "100"],
  temp: ["97", "98", "99", "100", "101", "102"],
  ht: ["150", "155", "160", "165", "170", "175"],
  wt: ["50", "55", "60", "65", "70", "75"]
};

export const cvsOptions = ["Normal", "Murmur", "Tachycardia", "Bradycardia"];
export const rsOptions = ["Clear", "Wheezing", "Crackles", "Decreased breath sounds"];
export const gitOptions = ["Normal", "Tenderness", "Distension", "Mass"];
export const gnsOptions = ["Alert", "Confused", "Drowsy", "Unconscious"];
export const expertOpinionOptions = ["Agree", "Disagree", "Needs further tests"];

export const investigationFields = {
  name: [
    "Hb", "PCV", "TC", "DC", "ESR", "Platelets", "BT", "CT", "PT", "INR", "aPTT",
    "Blood Sugar - Random", "Blood Sugar - FBS", "Blood Sugar - PPBS", "Blood Sugar - Urea", "Blood Sugar - Creatinine",
    "Blood Sugar - Electrolytes", "Na+", "K+", "CL-", "HCO-3",
    "Blood Group/Rh", "CXR", "ECG", "ECHO", "LFT", "TFT",
    "HIV", "HbeAg", "VDRL"
  ],
  key1: [
    'hb', 'pcv', 'tc', 'dc', 'esr', 'platelets', 'bt', 'ct', 'pt', 'inr', 'aptt',
    'blood_sugar_random', 'blood_sugar_fbs', 'blood_sugar_ppbs', 'blood_sugar_urea',
    'blood_sugar_creatinine', 'blood_sugar_electrolytes', 'na', 'k', 'cl', 'hco3',
    'blood_group_rh', 'cxr', 'ecg', 'echo', 'lft', 'tft', 'hiv', 'hbsag', 'vdrl'
  ]
};

export const investigationOptions = {
  hb: ['Normal', 'Low', 'High'],
  pcv: ['Normal', 'Low', 'High'],
  tc: ['Normal', 'Low', 'High'],
  dc: ['Normal', 'Low', 'High'],
  esr: ['Normal', 'Elevated'],
  platelets: ['Normal', 'Low', 'High'],
  bt: ['Normal', 'Abnormal'],
  ct: ['Normal', 'Abnormal'],
  pt: ['Normal', 'Abnormal'],
  inr: ['Normal', 'Abnormal'],
  aptt: ['Normal', 'Abnormal'],
  blood_sugar_random: ['Normal', 'Elevated', 'Low'],
  blood_sugar_fbs: ['Normal', 'Elevated', 'Low'],
  blood_sugar_ppbs: ['Normal', 'Elevated', 'Low'],
  blood_sugar_urea: ['Normal', 'Elevated', 'Low'],
  blood_sugar_creatinine: ['Normal', 'Elevated', 'Low'],
  blood_sugar_electrolytes: ['Normal', 'Abnormal'],
  na: ['Normal', 'Low', 'High'],
  k: ['Normal', 'Low', 'High'],
  cl: ['Normal', 'Low', 'High'],
  hco3: ['Normal', 'Low', 'High'],
  blood_group_rh: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
  cxr: ['Normal', 'Abnormal'],
  ecg: ['Normal', 'Abnormal'],
  echo: ['Normal', 'Abnormal'],
  lft: ['Normal', 'Abnormal'],
  tft: ['Normal', 'Abnormal'],
  hiv: ['Positive', 'Negative'],
  hbsag: ['Positive', 'Negative'],
  vdrl: ['Positive', 'Negative'],
};

export const planOptions = [
  "General Anesthesia", "Regional Anesthesia", "Local Anesthesia", 
  "Sedation", "Spinal Anesthesia", "Epidural Anesthesia",
];

export const preOpInstructionsOptions = [
  "Nil per oral after midnight", "No blood thinners for 5 days", 
  "Take morning medications with a sip of water", "Arrive 2 hours before surgery", 
  "Avoid smoking for 24 hours",
];

export const instructionsOptions = [
  "Take medications as prescribed", "Avoid heavy meals before surgery", 
  "Follow fasting guidelines", "Bring previous medical reports", 
  "Arrange for post-op transport",
];

export const npoOrdersOptions = [
  "No food 8 hours prior", "No fluids 4 hours prior", "Clear liquids allowed", 
  "No chewing gum", "No smoking",
];

export const reAssessmentOptions = [
  "Stable", "Requires monitoring", "Urgent intervention needed", 
  "Improving", "Declining",
];

export const investigationsListOptions = [
  "CBC", "X-Ray Chest", "ECG", "Blood Sugar", "LFT", "Electrolytes", "Urine Analysis",
];

export const nurseGroups = {
  ICU: [
    "Nurse Anna Smith", "Nurse Brian Lee", "Nurse Carol White",
    "Nurse David Green", "Nurse Emma Black", "Nurse Frank Harris",
  ],
  Pediatrics: [
    "Nurse Emily Davis", "Nurse Frank Miller", "Nurse Grace Wilson",
    "Nurse Hannah Moore", "Nurse Ian Clark", "Nurse Julia Lewis",
  ],
  GeneralWard: [
    "Nurse Henry Brown", "Nurse Irene Clark", "Nurse Jack Harris",
    "Nurse Kelly Martinez", "Nurse Liam Thompson", "Nurse Mia Anderson",
  ],
  Emergency: [
    "Nurse Karen Scott", "Nurse Larry Adams", "Nurse Monica Turner",
    "Nurse Nathan Hill", "Nurse Olivia King", "Nurse Peter Wright",
  ],
  Surgery: [
    "Nurse Quinn Young", "Nurse Rachel Walker", "Nurse Samuel Hall",
    "Nurse Tina Allen", "Nurse Victor Baker", "Nurse Wendy Nelson",
  ],
  Maternity: [
    "Nurse Xavier Perez", "Nurse Yolanda Roberts", "Nurse Zoe Campbell",
    "Nurse Aaron Phillips", "Nurse Bethany Parker", "Nurse Chris Turner",
  ],
};

export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown",
    "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson",
    "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia", "Dr. Jennifer Harris", "Dr. Charles Clark",
    "Dr. Jessica Lewis", "Dr. Thomas Robinson", "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young", "Dr. Matthew Hall", "Dr. Donna Allen",
    "Dr. Steven King", "Dr. Michelle Wright", "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green", "Dr. Kevin Adams", "Dr. Laura Baker",
    "Dr. Mark Nelson", "Dr. Angela Carter", "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez", "Dr. Eric Roberts", "Dr. Deborah Turner",
    "Dr. Jason Phillips", "Dr. Rebecca Campbell", "Dr. Andrew Parker"
  ],
  AnaesthesiaSpecialists: [
    "Dr. Anil Mehta", "Dr. Priya Iyer", "Dr. Rakesh Nair",
    "Dr. Neha Sharma", "Dr. Vivek Rao", "Dr. Aarti Desai"
  ]
};

export const signatureMeta = {
  anaesthesiologist_signature: {
    dateKey: "anaesthesiologist_date",
    timeKey: "anaesthesiologist_time"
  },
  surgeon_signature: {
    dateKey: "surgeon_date",
    timeKey: "surgeon_time"
  },
  nurse_signature: {
    dateKey: "nurse_date",
    timeKey: "nurse_time"
  }
};
